import React from "react";
import "./header.css";
import CV from "../../../res/PraveenPremasingheCV.pdf";
import Me from "../../../res/avatars/1.png";

import HeaderSocials from "./HeaderSocials";
import { motion } from "framer-motion";

const Header = () => {
  return (
    <header>
      <div className="container header__container">






        
        <motion.h4
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
        >
          Hello
        </motion.h4>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
        >
       <div className="myname"> I'm Praveen Premasinghe</div>  
        </motion.h1>
        <motion.h5
          // className="text-light"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
         {/* <div ><span className="job-title"> Front-End Developer & UI/UX Designer </span></div> */}
          
        <button  className="job-title">  Front-End Developer & UI/UX Designer </button>

        </motion.h5>
   

        <HeaderSocials />
        <div class="block">
        <div className="me">
          <img
            src={Me}
            alt="Me"
            className="me1"
          />
          </div>
    
        
        </div>
        
        <div className="cta">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.8 }}
            href={CV}
            className="btn"
            target={"_blank"}
            rel={"noreferrer"}
          >
            Download CV
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.8 }}
            href="#contact"
            className="btn btn-primary"
          >
            Get in Touch
          </motion.a>
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
